<template>
  <div class="contract-assocation-manager">
    <contract-select
      v-model="contract"
      @input-type="(v) => (contractType = v)"
      @fetch="fetchActiveAssocs"
      ref="contractSelect"
    />
    <contract-association-table
      :fetch="fetchAssocs"
      :columns="tableColumns"
      :checked="tableChecked"
      :disabled="!contractType"
      @check="onTableCheck"
      ref="contractAssocTable"
    />
  </div>
</template>

<script>
import ContractAssociationTable from "@/components/Contract/ContractAssociationTable";
import ContractSelect from "@/components/Contract/ContractSelect";
import { ContractService } from "@/services/contract.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  contractService: ContractService,
  props: {
    assocFetch: {
      required: true,
    },
    assocFetchActive: {
      required: true,
    },
    assocArchive: {
      required: true,
    },
    assocRestore: {
      required: true,
    },
    tableColumns: {
      type: Array,
    },
  },
  components: {
    ContractAssociationTable,
    ContractSelect,
  },
  data: () => ({
    contractType: "",
    contract: "",
    /**
     * Grouped by contract type and contract
     */
    contractAssocs: {},
  }),
  computed: {
    tableChecked() {
      if (this.contractAssocs[this.contractType]) {
        if (this.contract) {
          return this.contractAssocs[this.contractType][this.contract] || [];
        } else {
          let contractsCount = Object.keys(
            this.contractAssocs[this.contractType]
          ).length;
          let assocs = [];
          Object.values(this.contractAssocs[this.contractType]).forEach((v) => {
            assocs.push(...v);
          });
          return assocs.reduce((acc, v) => {
            if (!acc.find((vv) => v.id == vv.id)) {
              acc.push({
                id: v.id,
                indeterminate:
                  assocs.filter((vv) => v.id == vv.id).length != contractsCount,
              });
            }
            return acc;
          }, []);
        }
      }
      return [];
    },
  },
  methods: {
    fetchAssocs(payload) {
      return this.assocFetch(payload);
    },
    async fetchActiveAssocs() {
      if (this.contractType && !this.contractAssocs[this.contractType]) {
        try {
          this.$refs.contractAssocTable.$refs.baseTable.loading = true;
          const contracts =
            this.$refs.contractSelect.$refs.selectContract.options;
          const contractAssocFetches = contracts.map((v) =>
            this.assocFetchActive({ contract_id: v.id }).then((response) =>
              JsonDenormalizer.denormalize(response)
            )
          );
          const responses = await Promise.all(contractAssocFetches);
          const contractAssocs = {};
          contracts.forEach((v, k) => {
            contractAssocs[v.id] = responses[k];
          });
          this.$set(this.contractAssocs, this.contractType, contractAssocs);
        } catch (err) {
          throw err;
        } finally {
          this.$refs.contractAssocTable.$refs.baseTable.loading = false;
        }
      }
    },
    /**
     * Directly modifies UI data
     */
    archiveRestoreAssoc_(archiveRestore, id, contractType, contract = null) {
      if (contract) {
        if (archiveRestore == "archive") {
          const index = this.contractAssocs[contractType][contract].findIndex(
            (v) => (v.id == id)
          );
          if (index > -1) {
            this.contractAssocs[contractType][contract].splice(index, 1);
          }
        } else {
          this.contractAssocs[contractType][contract].push({ id });
        }
      } else {
        const contracts =
          this.$refs.contractSelect.$refs.selectContract.options;
        contracts.forEach((v) => {
          this.archiveRestoreAssoc_(archiveRestore, id, contractType, v.id);
        });
      }
    },
    async onTableCheck(checked, row) {
      if (!this.contractType) return;
      if (row) {
        try {
          this.$refs.contractAssocTable.$refs.baseTable.loading = true;
          const payload = {
            id: row.id,
          };
          if (this.contract) {
            payload.contract_id = this.contract;
          } else {
            const contracts =
              this.$refs.contractSelect.$refs.selectContract.options.map(
                (v) => v.id
              );
            payload.contract_ids = contracts;
          }
          if (checked) {
            await this.assocRestore(payload);
            this.archiveRestoreAssoc_(
              "restore",
              row.id,
              this.contractType,
              this.contract
            );
          } else {
            await this.assocArchive(payload);
            this.archiveRestoreAssoc_(
              "archive",
              row.id,
              this.contractType,
              this.contract
            );
          }
        } catch (err) {
          throw err;
        } finally {
          this.$refs.contractAssocTable.$refs.baseTable.loading = false;
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Contract/ContractAssociationManager.vue